/* eslint-disable prettier/prettier */
import React from 'react';
import { action, decorate, observable, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';

class Documentation extends React.Component {

    constructor() {
        super();
        this.iframeRef = React.createRef();
        this.loadTimeout = null;
        runInAction(()=>{
            this.failedToLoad = false;
        });
    }

    setLoadError = () => {
        this.failedToLoad = true;
    }

    componentDidMount() {
        // Fallback timeout in case iframe never loads
        this.loadTimeout = setTimeout(() => {
            runInAction(() => {
                this.failedToLoad = true;
            });
        }, 10000);

        // Check for ad blocker after a short delay
        setTimeout(() => {
            const iframe = this.iframeRef.current;
            if (iframe && (!iframe.src || iframe.src === 'about:blank')) {
                runInAction(() => {
                    this.failedToLoad = true;
                });
            }
        }, 100);

        // Listen for CSP violations
        document.addEventListener('securitypolicyviolation', this.handleCSPViolation);
    }

    componentWillUnmount() {
        if (this.loadTimeout) clearTimeout(this.loadTimeout);
        document.removeEventListener('securitypolicyviolation', this.handleCSPViolation);
    }

    handleCSPViolation = (event) => {
        if (event.blockedURI?.includes(process.env.REACT_APP_DOCUMENTATION_URL)) {
            runInAction(() => {
                this.failedToLoad = true;
            });
        }
    }

    iframeOnLoad = () => {
        if (this.loadTimeout) {
            clearTimeout(this.loadTimeout);
            this.loadTimeout = null;
        }
    }

    render() {
        return (
            this.failedToLoad ? 
            
            <div className='fallback race-documentation-if'>
                <div className='content-wrapper'>
                    <div>This page could not be loaded.</div>
                    <div>Please click the link below to open in a new tab:</div>
                    <a href={process.env.REACT_APP_DOCUMENTATION_URL} target='_blank' rel='noopener noreferrer'>
                        {process.env.REACT_APP_DOCUMENTATION_URL}
                    </a> 
                </div>
            </div> :
            
            <iframe 
                ref={this.iframeRef}
                src={process.env.REACT_APP_DOCUMENTATION_URL} 
                title='RACE Documentation' className='race-documentation-if' 
                onError={this.setLoadError} 
                onLoad={this.iframeOnLoad}
            />
        )
    }
}

decorate(Documentation, {
    failedToLoad: observable,
    setLoadError: action
})

export default withRouter(observer(Documentation));